import { TabStyles } from '@tableau/widgets';
import React from 'react';

import { Messages } from '../../codegen/Localize';
import { CommonStyles } from '../../common/react/CommonStyles';
import { filePathDisplayStringWithoutBaseName } from '../../common/utilities/FilePathUtils';
import { classes, cssClass, flexColumnStyle, flexRowStyle, textEllipsis } from '../../style/index';
import { FileConnectionDetail } from '../../ts/ServerApi/types/ConnectionDetail';
import { FlowOutputStepInfo } from '../models/FlowOutputStepInfo';
import { grey230border } from '../styles/FlowStyleConstants';
import { getConnectionText } from '../utils/FlowDataConnectionUtils';

const maxWidth = 200;

const cssPrefix = 'FlowOutputStepCard';

const rootClass = cssClass(cssPrefix, 'root', {
  padding: TabStyles.Spacing.DefaultSpace,
});
const selectableClass = cssClass(cssPrefix, 'selectable', {
  border: grey230border,
  userSelect: 'none',
  '-moz-user-select': 'none',
  '-ms-user-select': 'none',
  '-webkit-user-select': 'none',
  cursor: 'pointer',
});
const selectedCard = cssClass(cssPrefix, 'selectedCard', {
  border: `1px solid ${CommonStyles.Colors.Grey153}`
});
const titleClass = cssClass(cssPrefix, 'title', textEllipsis);
export const rowContainer = cssClass(cssPrefix, 'rowContainer', flexRowStyle);
export const columnFlexContainer = cssClass(cssPrefix, 'columnFlexContainer', flexColumnStyle);
const boldText = cssClass(cssPrefix, 'boldText', {
  fontWeight: 'bold'
});
const leftOutputStepColumn = cssClass(cssPrefix, 'leftOutputStepColumn', {
  marginRight: TabStyles.Spacing.MediumSpace,
  flex: '0 1 auto'
});
export const rightOutputStepColumn = cssClass(cssPrefix, 'rightOutputStepColumn', {
  overflow: 'hidden',
  maxWidth: maxWidth
});
export const tooltipItem = cssClass(cssPrefix, 'tooltipItem', textEllipsis, {
  paddingTop: TabStyles.Spacing.DefaultSpace,
});

export type FlowOutputStepCardProps = {
  readonly outputStep: FlowOutputStepInfo;
  readonly checked?: boolean;
  readonly outputSelected?: (id: string) => void;
};

export class FlowOutputStepCard extends React.PureComponent<FlowOutputStepCardProps> {

  private handleChange = () => {
    this.props.outputSelected && this.props.outputSelected(this.props.outputStep.id);
  }

  public render(): JSX.Element {
    const cardClasses = this.props.outputSelected ? classes(rootClass, selectableClass) : rootClass;
    const filePath: string = filePathDisplayStringWithoutBaseName((this.props.outputStep.dataConnection.connectionDetails as FileConnectionDetail).fileName);
    const fileLocation: string = filePath ? filePath : getConnectionText(this.props.outputStep.dataConnection);
    /* eslint-disable jsx-a11y/no-static-element-interactions */
    /* eslint-disable jsx-a11y/click-events-have-key-events */
    return (
      <div className={classes(cardClasses, this.props.checked && selectedCard)} onClick={this.handleChange}>
        <div className={classes(titleClass, 'tb-content-item-popover-title')} title={this.props.outputStep.name}>
          {this.props.outputStep.name}
        </div>
        <div className={rowContainer}>
          <div className={classes(columnFlexContainer, boldText, leftOutputStepColumn)}>
            <div className={tooltipItem}>{Messages.flowOverviewOutputType()}</div>
            <div className={tooltipItem}>{Messages.flowOverviewName()}</div>
            <div className={tooltipItem}>{Messages.flowOverviewOutputLocation()}</div>
          </div>
          <div className={classes(columnFlexContainer, rightOutputStepColumn)}>
            <div className={tooltipItem} title={this.props.outputStep.dataConnection.connectionTypeDisplayName}>{this.props.outputStep.dataConnection.connectionTypeDisplayName}</div>
            <div className={tooltipItem} title={this.props.outputStep.datasourceName}>{this.props.outputStep.datasourceName}</div>
            <div className={tooltipItem} title={fileLocation}>{fileLocation}</div>
          </div>
        </div>
      </div>
    );
  }
}
